import React, { memo } from 'react';
import { Text, View } from 'react-native';
import { getBoxShadowStyle } from '@styles/shadow';
import { scale } from '@components/frame';
import Line from '@components/common/line';
import { font } from '@styles/fonts';
import { SCREEN_BORDER_RADIUS } from '@v2/pages/common/constants/base.constants';

export const MachineDetailsFields = memo(function MachineDetailsFields({ details, C, label, style, description }) {
  if (!details || details.length === 0) {
    return null;
  }


  return (
    <View style={[{ width: '100%', marginTop: scale(20) }, style]}>
      {label ? (
        <View
          style={{
            paddingHorizontal: scale(15),
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginBottom: scale(5),
          }}
        >
          <Text
            style={[
              {
                color: C('Label/Light/Tertiary'),
              },
              font.Footnote,
            ]}
          >
            {label}
          </Text>
        </View>
      ) : null}
      <View style={[getBoxShadowStyle({type: 'Field', C}), {  width: '100%', borderRadius: scale(SCREEN_BORDER_RADIUS) }]}>
        {details.map((item, index) => (
          <Line
            key={index}
            {...{
              C,
              index,
              item,
              array: details,
              roundTop: index === 0,
              roundBottom: details.length - 1 === index,
            }}
          />
        ))}
      </View>
      {description ? (
        <View style={{ paddingHorizontal: scale(15), marginTop: scale(6) }}>
          <Text style={[font['Caption 1'], { color: C('Label/Light/Tertiary') }]}>{description}</Text>
        </View>
      ) : null}
    </View>
  );
});

export default MachineDetailsFields;
